import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TrackFalseSlider from './TrackFalseSlider';
import ClientProvider from './client';
export default createDemo(import.meta.url, TrackFalseSlider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/track-false/TrackFalseSlider.tsx",
    "fileName": "TrackFalseSlider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Slider from '@mui/material/Slider';\n\nconst Separator = styled('div')(\n  ({ theme }) => `\n  height: ${theme.spacing(3)};\n`,\n);\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function TrackFalseSlider() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const rangeId = React.useId();\n  return (\n    <Box sx={{ width: 250 }}>\n      <Typography id={`${id}-label`} gutterBottom>\n        Removed track\n      </Typography>\n      <Slider\n        track={false}\n        aria-labelledby={`${id}-label`}\n        getAriaValueText={valuetext}\n        defaultValue={30}\n        marks={marks}\n      />\n      <Separator />\n      <Typography id={`${rangeId}-label`} gutterBottom>\n        Removed track range slider\n      </Typography>\n      <Slider\n        track={false}\n        aria-labelledby={`${rangeId}-label`}\n        getAriaValueText={valuetext}\n        defaultValue={[20, 37, 50]}\n        marks={marks}\n      />\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 64,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Slider from '@mui/material/Slider';\n\nconst Separator = styled('div')(\n  ({ theme }) => `\n  height: ${theme.spacing(3)};\n`,\n);\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nexport default function TrackFalseSlider() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const id = React.useId();\n  const rangeId = React.useId();\n  return (\n    <Box sx={{ width: 250 }}>\n      <Typography id={`${id}-label`} gutterBottom>\n        Removed track\n      </Typography>\n      <Slider\n        track={false}\n        aria-labelledby={`${id}-label`}\n        getAriaValueText={valuetext}\n        defaultValue={30}\n        marks={marks}\n      />\n      <Separator />\n      <Typography id={`${rangeId}-label`} gutterBottom>\n        Removed track range slider\n      </Typography>\n      <Slider\n        track={false}\n        aria-labelledby={`${rangeId}-label`}\n        getAriaValueText={valuetext}\n        defaultValue={[20, 37, 50]}\n        marks={marks}\n      />\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 64,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Typography",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
